export interface IBaseApiResponse {
  success: boolean;
  errors: string[];
}

export class BaseApiResponse
  implements IBaseApiResponse {
  success: boolean;
  errors: string[];
}
